import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

const initialState = {
  categories: [],
  isLoadCategories: false,
  attributes: null,
  isLoadAttributes: false,
};

export const getCategoriesTiki = createAsyncThunk(
  "Tiki/getCategoriesTiki",
  async () => {
    const response = await http.get("/categories-tiki");
    return response.data.data;
  }
);

export const getCategoryAttributesTiki = createAsyncThunk(
  "Tiki/getCategoryAttributesTiki",
  async (categoryId) => {
    const response = await http.get(`/category-attributes-tiki?category_id=${categoryId}`);
    return response.data.data;
  }
);

const getCategoryTiki = createSlice({
  name: "getCategoryTiki",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategoriesTiki.pending, (state) => {
        state.isLoadCategories = true;
      })
      .addCase(getCategoriesTiki.fulfilled, (state, action) => {
        state.categories = action.payload?.data || action.payload || [];
        state.isLoadCategories = false;
      })
      .addCase(getCategoriesTiki.rejected, (state) => {
        state.isLoadCategories = false;
      })
      .addCase(getCategoryAttributesTiki.pending, (state) => {
        state.isLoadAttributes = true;
      })
      .addCase(getCategoryAttributesTiki.fulfilled, (state, action) => {
        state.attributes = action.payload?.data || action.payload || null;
        state.isLoadAttributes = false;
      })
      .addCase(getCategoryAttributesTiki.rejected, (state) => {
        state.isLoadAttributes = false;
      });
  },
});

export default getCategoryTiki.reducer;
